// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"4f101b71","192":"33c2e26b","871":"b29a4c59"}[chunkId] + ".chunk.css";
};